/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datagrid_Togglecolumns2Inputs */

const en_datagrid_togglecolumns2 = /** @type {(inputs: Datagrid_Togglecolumns2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle columns`)
};

/**
* | output |
* | --- |
* | "Toggle columns" |
*
* @param {Datagrid_Togglecolumns2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const datagrid_togglecolumns2 = /** @type {((inputs?: Datagrid_Togglecolumns2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datagrid_Togglecolumns2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_datagrid_togglecolumns2(inputs)
});
export { datagrid_togglecolumns2 as "dataGrid_toggleColumns" }